import React from 'react';
import '../../assets/styles/static-styles/ChatBot.css';

function BotAvatar(props) {
  return (
    <div className='bot-avatar'></div>
  );
}

export default BotAvatar;
